//Component that creates the links and tooltip popup
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';
import ReactTooltip from 'react-tooltip';

const TooltipUser = (tooltipType, linkText, contentObj, type, index, uniqueIdName, state, actions, householdId, authenticatedCallerGuid, applicantGuid, isChatAuth) => {
    //If the broker or assister name does not exist in the data we will populate a generic name
    if (type === 'broker') {
        if(linkText === 'undefined undefined') {
            linkText = 'Broker';
        }
    } else if (type === 'assister') {
        if(linkText === 'undefined undefined') {
            linkText = 'Assister';
        }
    } else if (type === 'authRep') {
        if(linkText === 'undefined undefined') {
            linkText = 'Authorized Rep.';
        }
    }

    const highlightClass = (applicantGuid && authenticatedCallerGuid === applicantGuid) || isChatAuth ? 'highlight-caller' : '';

    //************************************************************
    //Returning a link with the tooltip content
    return (<Fragment key={`${type}-tooltip-data-${index}`}>
        <a data-tip
            data-for={`${type}'_tooltip_${index}_${uniqueIdName}`}
            className={`text-base text-underline cursor-pointer ${highlightClass}`}
        >
            <FormattedMessage id='common.non_internationalized_text' values={{ text: linkText }}/>
        </a>
        <div tabIndex='0'>
            <ReactTooltip
                place='bottom'
                type='light'
                effect='solid'
                multiline={true}
                border={true}
                borderColor={'black'}
                className='tooltip-component'
                clickable={true}
                delayHide={500}
                delayShow={500}
                delayUpdate={500}
                id={`${type}'_tooltip_${index}_${uniqueIdName}`}
            >
                { tooltipType === 'screenpop' &&
                    renderedContentScreenpop(contentObj, type, index, uniqueIdName, linkText, state, actions, householdId)
                }
            </ReactTooltip>
        </div>
    </Fragment>);
};
//end of ToolTipUser
//************************************************************


//************************************************************
//Conditional content that is rendered in the tooltip depending on the type of user starts here
const renderedContentScreenpop = (contentObj, type, index, uniqueIdName, linkText, confirmedCaller, handleConfirmCaller, householdId) => {
    let hasContactInfo = (contentObj.phone || contentObj.email);
    let ssnOrNull = contentObj.last4Ssn ? `(${contentObj.last4Ssn})` : '';

    if (type === 'member') {
        return (
            <Fragment>
                <strong className='popup-header__name'>
                    <FormattedMessage id='screenpop.tooltip.name' values={{ firstName: contentObj.firstName, ssnOrNull }} tagName='p'/>
                </strong>

                {hasContactInfo &&
                <strong className='popup-header'>
                    <FormattedMessage id='screenpop.tooltip.contact_info' tagName='p'/>
                </strong>
                }
                {contentObj.phone &&
                <Fragment>
                    <FormattedMessage id='screenpop.tooltip.phone' values={{ phone: contentObj.phone }} tagName='p'/>
                </Fragment>

                }
                {contentObj.email &&
                <Fragment>
                    <FormattedMessage id='screenpop.tooltip.email' values={{ email: contentObj.email }} tagName='p'/>
                </Fragment>

                }

                {contentObj.homeAddress &&
                <Fragment>
                    <strong className='popup-header'>
                        <FormattedMessage id='screenpop.tooltip.home_address' tagName='p'/>
                    </strong>
                    <FormattedMessage id='common.non_internationalized_text' values={{ text: contentObj.homeAddress.address1 }} tagName='p'/>
                    <FormattedMessage id='common.non_internationalized_text' values={{ text: `${contentObj.homeAddress.city}, ${contentObj.homeAddress.state}, ${contentObj.homeAddress.zip}` }} tagName='p'/>
                </Fragment>
                }


                {contentObj.mailingAddress &&
                <Fragment>
                    <strong className='popup-header'>
                        <FormattedMessage id='screenpop.tooltip.mailing_address' tagName='p'/>
                    </strong>
                    <FormattedMessage id='common.non_internationalized_text' values={{ text: contentObj.mailingAddress.address1 }} tagName='p'/>
                    <FormattedMessage id='common.non_internationalized_text' values={{ text: `${contentObj.mailingAddress.city}, ${contentObj.mailingAddress.state}, ${contentObj.mailingAddress.zip}` }} tagName='p'/>
                </Fragment>
                }
            </Fragment>
        );

    } else if (type === 'broker') {
        return (
            <Fragment>
                <strong className='popup-header__name'>
                    <FormattedMessage id='common.non_internationalized_text' values={{ text: linkText }} tagName='p'/>
                </strong>

                <FormattedMessage id='screenpop.tooltip.broker' tagName='p'/>
                <FormattedMessage id='screenpop.tooltip.email' values={{ email: contentObj.email }} tagName='p'/>
                <FormattedMessage id='screenpop.tooltip.npn' values={{ npn: contentObj.npn }} tagName='p'/>
                <FormattedMessage id='screenpop.tooltip.license' values={{ license: contentObj.license }} tagName='p'/>
                { confirmedCaller[`BROKER${index}`] ?
                    <button className='usa-button gi-button green-disabled' disabled>
                        <FormattedMessage id='screenpop.button.confirmed'/>
                    </button>
                    : <button className='usa-button gi-button gi-button__gray' type='button' onClick={(e) => handleConfirmCaller(householdId, index, 'BROKER', e)}>
                        <FormattedMessage id='screenpop.button.confirm_caller'/>
                    </button>
                }

            </Fragment>
        );
    } else if (type === 'assister') {
        return (
            <Fragment>
                <strong className='popup-header__name'>
                    <FormattedMessage id='common.non_internationalized_text' values={{ text: linkText }} tagName='p'/>
                </strong>

                <FormattedMessage id='screenpop.tooltip.assister' tagName='p'/>
                <FormattedMessage id='screenpop.tooltip.phone' values={{ phone: contentObj.phone }} tagName='p'/>
                <FormattedMessage id='screenpop.tooltip.email' values={{ email: contentObj.email }} tagName='p'/>
                {confirmedCaller[`ASSISTER${index}`] ?
                    <button className='usa-button gi-button green-disabled' disabled>
                        <FormattedMessage id='screenpop.button.confirmed'/>
                    </button>
                    : <button className='usa-button gi-button gi-button__gray' type='button' onClick={(e) => handleConfirmCaller(householdId, index, 'ASSISTER', e)}>
                        <FormattedMessage id='screenpop.button.confirm_caller'/>
                    </button>
                }
            </Fragment>
        );
    } else if (type === 'authRep') {
        return (
            <Fragment>
                <strong className='popup-header__name'>
                    <FormattedMessage id='common.non_internationalized_text' values={{ text: linkText }} tagName='p'/>
                </strong>
                { contentObj.phone &&
                <Fragment>
                    <FormattedMessage id='screenpop.tooltip.phone' values={{ phone: contentObj.phone }} tagName='p'/>
                </Fragment>

                }
            </Fragment>
        );
    } else {
        return (
            <Fragment>
                <strong className='popup-header__name'>
                    <FormattedMessage id='common.non_internationalized_text' values={{ text: linkText }} tagName='p'/>
                </strong>
            </Fragment>
        );
    }
};
//end of conditional rendering of tooltip


export default TooltipUser;